import { useFallbackStorageValue } from "~/lib/hooks";
export const useIsFirstTimeVisitDashboardWidget = () => {
  const {
    set: setIsFirstTime,
    value: isFirstTime
  } = useFallbackStorageValue("isFirstTimeVisitSCMPNotificationWidgetVersionTwo", {
    defaultValue: true
  });
  return {
    isFirstTime,
    setIsFirstTime
  };
};